<div class="menu">
	<ul>
		<li>
			<a routerLink="/portal" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" (click)="onHomeClicked()" translate>pub.menu.home</a>
		</li>
		<li>
			<a routerLink="/portal/empresa-servicios-de-facturacion" routerLinkActive="active" class="menuListado_element_to_target" translate>pub.menu.ESFList</a>
		</li>
	</ul>
</div>




// WEBPACK FOOTER //
// ./src/app/app-public/pub-menu/pub-menu.component.html